<template>
  <div class="my-4 pl-0  px-2 d-flex align-content-center" :style="{'background-color': isTargetShop ? '#FFA300' : $colorSub,}">
    <v-row class="py-2" no-gutters>
      <v-col class="pl-0 font18">
        <div class="d-flex justify-content-start ps-3">
          <img v-if="!isTargetShop"   :src="rewardIcon" class="me-2" width="30" height="30" />
          <div class="pb-0 ms-2" :style="{'color': textColor}">
            {{ $t("message.reward") }}
          </div>
        </div>
      </v-col>
      <v-col
        class="text-end link"
        @click="$router.push('/C/reward')"
        >
        <div class="pb-0 ms-2" :style="{'color': textColor}">
          {{ $t("message.viewAll") }}
          <v-icon :style="{'color': textColor}">mdi-chevron-right</v-icon>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.v-sheet.v-card {
    border-radius: 18px;
    background-color: white !important;
}
#primary {
  background-color: #181446;
}
</style>
<script>
export default {
  props: {
    top: {
      type: Number,
      default: 0
    },
    levelById: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // levelById: null
    }
  },
  computed: {
    computedStyle () {
      return this.isTargetShop ? this.fontColorLMG : this.$textcolor
    },
    isTargetShop () {
      return this.$isTargetShop()
    },
    textColor () {
      return this.isTargetShop ? '#000' : this.$colorSub2
    },
    rewardIcon () {
      return this.isTargetShop ? this.$images.myReward : (this.$colorSub3 ? this.$images.myReward : this.$images.myRewardWhite)
    }
  },
  async mounted  () {
    await this.getLevelById()
  },
  methods: {
    async getLevelById () {
      if (!this.member || !this.member.levelId) {
        this.levelById = null
        return
      }
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${this.member.levelId}`
      )
      if (result) {
        this.levelById = result
      } else {
        this.levelById = null
      }
    },
    HEXToVBColorLMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return '#E0E0E0'
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      // console.log('brightness', brightness)

      if (brightness > 180) {
        return '#000000' // สีเข้ม
      } else {
        return '#FFFFFF' // สีขาว
      }
    },
    HEXTHEMELMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return true
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      return brightness > 180
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layouts/Rewards.vue